/* KoreanCare ChatGPT Ads. No API credentials. Version 2026-09-09. */
(function () {
  'use strict';
  if (window.BSMOpenAI) return;
  var node = document.getElementById('bsm-openai-config');
  if (!node || !window.fetch) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var nativeFetch = window.fetch.bind(window), allowed = false, saleAllowed = false;
  var root = config.root || '/';
  if (!root.endsWith('/')) root += '/';
  var viewsSent = false, synced = '', syncChain = Promise.resolve(), checkoutAt = 0;
  var cart = null, active = false;
  var testMode = new URL(location.href).searchParams.get('bsm_oai_test') === '1';
  var debugEvents = [];
  function uid() { return window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2); }
  function cookie(name) {
    var part = document.cookie.split('; ').find(function (s) { return s.indexOf(name + '=') === 0; });
    if (!part) return '';
    try { return decodeURIComponent(part.slice(name.length + 1)); } catch (_) { return ''; }
  }
  function item(li) {
    return { id: 'shopify_' + li.product_id + '_' + (li.variant_id || li.id),
      name: String(li.product_title || li.title || '').slice(0, 150), content_type: 'product',
      quantity: Number(li.quantity || 1), amount: Math.round(Number(li.final_price == null ? li.price : li.final_price)), currency: config.currency };
  }
  function measure(name, data, id) {
    if (!allowed) return;
    var options = { event_id: id || uid(), opt_out: !saleAllowed };
    if (testMode) { debugEvents.push({ name: name, data: data, options: options }); return; }
    window.oaiq('measure', name, data, options);
  }
  function attributes() {
    return { _bsm_oai_consent: allowed ? 'granted' : 'denied', _bsm_oai_sale: saleAllowed ? 'granted' : 'denied',
      _bsm_oai_origin: location.origin, _bsm_oai_oppref: allowed ? cookie('__oppref') : '',
      _bsm_oai_obref: allowed ? cookie('__obref') : '' };
  }
  function addFormAttributes(form) {
    var attrs = attributes();
    Object.keys(attrs).forEach(function (key) {
      var name = 'attributes[' + key + ']';
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
      input.value = attrs[key];
    });
  }
  function syncAttributes() {
    var attrs = attributes(), value = JSON.stringify(attrs);
    if (testMode || value === synced) return syncChain;
    // Serialize writes so revocation cannot be overwritten by an older grant.
    syncChain = syncChain.catch(function () {}).then(function () {
      return nativeFetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }), keepalive: true }).then(function (r) {
          if (!r.ok) throw Error('cart attributes not saved');
          synced = value;
        });
    });
    return syncChain;
  }
  function readCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw Error('cart unavailable'); return r.json(); })
      .then(function (data) { cart = data; return data; });
  }
  function sendViews() {
    if (!allowed || viewsSent) return;
    viewsSent = true;
    measure('page_viewed', { type: 'contents' });
    if (config.product) {
      var product = config.product;
      var selected = new URL(location.href).searchParams.get('variant') || product.selectedVariant;
      var variant = product.variants.find(function (v) { return String(v.id) === String(selected); }) || product.variants[0];
      if (variant) measure('contents_viewed', { type: 'contents', amount: variant.price, currency: config.currency,
        contents: [item({ product_id: product.id, variant_id: variant.id, title: product.title, quantity: 1, price: variant.price })] });
    }
  }
  function applyConsent() {
    var privacy = window.Shopify && Shopify.customerPrivacy;
    if (!privacy) return;
    var next = privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true;
    saleAllowed = privacy.saleOfDataAllowed() === true;
    allowed = next;
    if (!testMode) window.oaiq('consent', next);
    sendViews();
    syncAttributes().catch(function () {});
  }
  function init() {
    if (active) return;
    active = true;
    if (!testMode) {
      if (!window.oaiq) {
        var q = function () { q.q.push(arguments); }; q.q = []; window.oaiq = q;
        var sdk = document.createElement('script'); sdk.async = true; sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js'; document.head.appendChild(sdk);
        sdk.onload = function () { syncAttributes().catch(function () {}); };
      }
      window.oaiq('consent', false);
      window.oaiq('init', { pixelId: config.pixelId, debug: false });
    }
    document.addEventListener('visitorConsentCollected', applyConsent);
    if (Shopify.customerPrivacy) applyConsent();
    else if (Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) applyConsent(); });
    // The SDK browser reference appears asynchronously after consent.
    var attempts = 0, refTimer = setInterval(function () {
      if (allowed) syncAttributes().catch(function () {});
      if (++attempts >= 10) clearInterval(refTimer);
    }, 1000);
    readCart().catch(function () {});
  }
  function requestedQuantities(body) {
    try {
      if (typeof body === 'string') { try { body = JSON.parse(body); } catch (_) { body = new URLSearchParams(body); } }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        if (body.get('id')) return [{ id: String(body.get('id')), quantity: Number(body.get('quantity') || 1) }];
        var entries = {};
        body.forEach(function (value, key) { var match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/); if (match) { entries[match[1]] = entries[match[1]] || {}; entries[match[1]][match[2]] = value; } });
        return Object.keys(entries).map(function (key) { return { id: String(entries[key].id), quantity: Number(entries[key].quantity || 1) }; });
      }
      return (body && (body.items || [body]) || []).filter(function (li) { return li.id; }).map(function (li) { return { id: String(li.id), quantity: Number(li.quantity || 1) }; });
    } catch (_) { return []; }
  }
  function added(data, requested) {
    if (!allowed || !data || data.status) return;
    var rows = data.items || [data];
    var used = {};
    var contents = rows.filter(function (li) { return li.product_id && (li.variant_id || li.id); }).map(function (li) {
      var result = item(li);
      var index = (requested || []).findIndex(function (r, i) { return !used[i] && r.id === String(li.variant_id || li.id); });
      if (index >= 0) { used[index] = true; result.quantity = requested[index].quantity; }
      else if (cart && cart.items) { var old = cart.items.find(function (row) { return row.key === li.key; }); result.quantity = Number(li.quantity) - Number(old && old.quantity || 0); }
      return result;
    }).filter(function (li) { return Number.isInteger(li.quantity) && li.quantity > 0; });
    if (contents.length) measure('items_added', { type: 'contents', amount: contents.reduce(function (sum, li) { return sum + li.amount * li.quantity; }, 0), currency: config.currency, contents: contents });
    syncAttributes().catch(function () {});
    readCart().catch(function () {});
  }
  // Observe successful cart mutations without modifying their response or timing.
  window.fetch = function (input, options) {
    var url, quantities;
    try { url = new URL(typeof input === 'string' ? input : input.url, location.href); } catch (_) { return nativeFetch(input, options); }
    if (url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname)) {
      try { quantities = input instanceof Request && !(options && options.body) ? input.clone().text().then(requestedQuantities).catch(function () { return []; }) : Promise.resolve(requestedQuantities(options && options.body)); }
      catch (_) { quantities = Promise.resolve([]); }
    }
    var response = nativeFetch(input, options);
    if (url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname)) {
      response.then(function (r) { if (r.ok) Promise.all([r.clone().json(), quantities]).then(function (parts) { added(parts[0], parts[1]); }).catch(function () {}); }).catch(function () {});
    }
    if (url.origin === location.origin && /\/cart\/(?:change|update|clear)(?:\.js)?$/.test(url.pathname)) {
      response.then(function (r) { if (r.ok) r.clone().json().then(function (c) { cart = c; }).catch(function () {}); }).catch(function () {});
    }
    return response;
  };
  // Some Shopify apps still use XMLHttpRequest for add-to-cart.
  var xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._bsmOaiUrl = String(url); return xhrOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var requested = requestedQuantities(arguments[0]);
    try { var u = new URL(xhr._bsmOaiUrl, location.href);
      if (u.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(u.pathname)) xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) try { added(xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText), requested); } catch (_) {}
      });
    } catch (_) {}
    return xhrSend.apply(this, arguments);
  };
  function checkout() {
    if (!allowed || Date.now() - checkoutAt < 3000) return;
    checkoutAt = Date.now();
    var data = { type: 'contents' };
    if (cart && cart.items) { data.amount = cart.total_price; data.currency = cart.currency || config.currency; data.contents = cart.items.map(item); }
    // Storefront transition only; checkout completion is measured server-side.
    measure('checkout_started', data);
    syncAttributes().catch(function () {});
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (/\/cart(?:\/add)?(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) addFormAttributes(form);
    var button = event.submitter;
    if (button && button.name === 'checkout') checkout();
  }, true);
  document.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href]');
    if (a) try { var u = new URL(a.href); if (u.origin === location.origin && /^\/checkouts?(?:\/|$)/.test(u.pathname)) checkout(); } catch (_) {}
  }, true);
  window.BSMOpenAI = { version: '2026-09-09', testMode: testMode, events: debugEvents,
    status: function () { return { consent: allowed, saleAllowed: saleAllowed, attributesSynced: !!synced, viewsSent: viewsSent }; } };
  if (window.Shopify) init();
  else document.addEventListener('DOMContentLoaded', function () { if (window.Shopify) init(); }, { once: true });
})();
